import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import { RiCloseCircleLine } from "react-icons/ri";
import { closeModal } from "../store/reducers/modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: { xs: "96%", md: "90%" },
  bgcolor: "background.paper",
  boxShadow: 24,
  py: 1,
  px: 3,
  borderRadius: 3,
  // display: {xs: "flex"}
};

export default function ExamBoardModal() {
  const [open, setOpen] = React.useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const dispatch = useDispatch();

  const state = useSelector((state) => state.modal);

  return (
    <>
      <Modal
        open={state.isOpen}
        keepMounted
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="rounded-[5px] w-100">
          <Box
            className="fixed right-[10px] top-[10px]"
            sx={{
              cursor: "pointer",
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "end",
            }}
            onClick={() => dispatch(closeModal())}
          >
            <RiCloseCircleLine size={20} />
          </Box>
          {state.content}
        </Box>
      </Modal>
    </>
  );
}
